/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkerService } from './services/worker.service';
import { WorkerIpcService } from '@core/worker/services/worker-ipc.service';
import { HttpClientModule } from '@angular/common/http';

/**
 * The worker module provides services to support the worker communication. The worker is responsible for retrieving
 * all Http requests within the Rebellion application. This module acts as an interface.
 *
 * The main interface that the UI interacts with is the WorkerService, it orchestrates all Http and offline handling.
 */
@NgModule({
  imports: [CommonModule, HttpClientModule],
  declarations: [],
  providers: [WorkerService, WorkerIpcService],
})
export class WorkerModule {}
